const pageBreakingRules = {
  pageBreakingRules: {
    text: "This tour has been removed from publication for violating platform rules",
  },
};

export { pageBreakingRules };
